export default {
  account_required: '请录入用户名',
  password_required: '请录入登录密码',
  confirm_password_different: '确认密码组合必须与全新密码保持一致',
  min_length: "必须超过6个或以上的字元",
  alphanumeric_char: "只可录入数字和大写字母字符。",
  list:{
    0: "你登录的时限已过, 请重新登录",
    OK: "交易识别码 (TAC) 发送成功", // for tac code
    ok: "交易识别码 (TAC) 发送成功", // for tac code
    CLOSE: "由于你在使用投注账户的过程中，违反了列示在EpicWin的公平竞争游戏细则规定，进而导致你的投注账户被禁用。",
    close: "由于你在使用投注账户的过程中，违反了列示在EpicWin的公平竞争游戏细则规定，进而导致你的投注账户被禁用。",
    accountIdRequired: '请录入用户名',
    passwordStrengthError: '创建一组你专属的登录密码。密码必须由至少6-20 个字符组成且得包含数字与大小写字母。.',
    session_expired : '时段结束',

    app_id_required: "申请标识不得留空",
    permission_denied: "权限被拒",
    account_id_required: "用户名/投注账户标识不得留空",
    verification_code_required: "认证码不得留空",
    account_not_exists: "查无此用户名/投注账户信息",
    account_inactive: "用户名/投注账户处于不活跃状态",
    verify_failed: "认证过程失败",
    parent_account_inactive: "上线账户处于不活跃状态",
    transfer_id_required: "转款标识不得留空",
    credit_amount_required: "收款额不得留空",
    duplicate_credit_record: "重复的提现记录",
    member_wallet_not_exists: "查无玩家的钱包信息",
    debit_amount_required: "转款额不得留空。",
    duplicate_debit_record: "重复的存款记录",
    insufficient_balance: "现有结余不足",
    result_exists: "已查阅到赛事结果记录。",
    debit_record_not_found: "查无任何存款记录。",
    bank_id_required: "银行标识不得留空。",
    bank_acc_no_required: "银行账号不得留空。",
    bank_acc_holder_required: "银行户名不得留空。",
    bank_already_setup: "银行账户已被设置。",
    platform_required: "平台不得留空。",
    parent_not_exists: "查无此上线信息",
    invalid_password: "登录密码录入有误。",
    parent_id_required: "上线标识不得留空。",
    password_required: "登录密码不得留空。",
    contact_phone_required: "联系号码不得留空。",
    account_exists: "用户/账户标识已被使用。",
    vip_mode_not_exists: "查无此尊荣模式。",
    session_not_exists: "你登录的时限已过, 请重新登录",
    ticket_id_required: "任务票单标识不得留空。",
    ref_id_required: "参考标识不得留空",
    ticket_not_exists: "查无此任务票单。",
    ticket_processed: "任务票单已被处理。",
    min_deposit_not_met: "存款额必须至少等同于最低起存额。",
    ongoing_promotion: "你尚参与着正在进行中的优惠活动。请在以后再提出申领要求。",
    invalid_promo_package: "优惠活动配套出错",
    promo_min_deposit_not_met: "存款额仍未达到本优惠活动所规定的最低起存额·要求。",
    claim_promo_only_once_a_day: "本优惠活动每天只能申领一次而已。",
    first_deposit_unmet: "已申领了每日首存彩金奖励。",
    newbie_unmet: "已领取了新手专属的开户迎新彩金奖励。",
    claim_promo_only_once: "本优惠活动只能申领一次而已。",
    inner_catch: "意想不到的故障",
    systemError: "系统哦故障",
    deposit_amount_required: "存款额不得留空。",
    target_bank_id_required: "目标银行标识不得留空。",
    target_bank_acc_no_required: "目标银行账号不得留空。",
    target_bank_acc_holder_required: "目标银行户名不得留空。",
    deposit_date_required: "存款日期不得留空。",
    deposit_method_required: "存款方式不得留空。",
    min_deposit_not_set: "尚未设置最低起存额。",
    min_balance_not_set: "尚未设置现有结余最低额。",
    ibank_account_not_exists: "查无此IBANK88账户信息",
    ibank_account_inactive: "IBANK88账户处于不活跃状态。",
    withdrawal_amount_required: "提现额不得留空",
    min_withdrawal_not_set: "尚未设置最低提现额。",
    bank_member_not_exists: "查无目标玩家的银行账户信息。",
    promotion_requirement_not_met: "尚未达成优惠活动所规定的获赏要求。",
    invalid_promotion: "优惠活动出错",
    new_password_required: "全新登录密码不得留空。",
    multiplier_not_found: "系统当前未能处理你所提交的任务要求，请在稍后重试。",
    contact_phone_exists: "此手机号码已被使用。",
    BLOCK: "你的投注账户已被禁用。",
    tac_is_valid: "你之前申请的交易识别码 (TAC) 仍处于可被使用的状态。",
    tac_expired: "你的交易识别码 (TAC)已超出执行时间。请再申请新的交易识别码 (TAC)",
    invalid_tac: "交易识别码 (TAC) 录入有误",
    tac_not_validate: "交易识别码 (TAC) 尚未被认证",
    tacCodeRequired: "请录入交易识别码 (TAC)",
    invalid_referral_code: "邀友代码录入有误",
    exceed_max_withdrawal: "超出提现上限。",
    bank_member_inactive: "银行用户处于不活跃状态。",
    loginFailed: "登录失败",
    loginSucceed: "登录成功",
    usernameRequired : "请录入用户名",
    passwordRequired : "请录入登录密码",
    logoutSucceed : "成功登出账户",
    logoutFailed : "登出失败",
    requestSucceed: "任务要求提交成功",
    requestFailed : "任务要求提交失败",
    requestProcessing : "你的任务要求正在处理中。",
    requestDelayed: "任务要求被推迟",
    verificationCodeRequired: "交易识别码 (TAC) 认证不得留空。",
    newPasswordRequired: "全新登录密码不得留空。",
    bankIdRequired: "请选择银行",
    bankNameRequired: "银行名称不得留空。",
    bankAccHolderRequired : "银行户名不得留空。",
    bankAccNoRequired: "银行账号不得留空。",
    depositAmountRequired: "请录入存款额",
    dateRequired: "请选择日期",
    bonusIdRequired: "请选择欲申领的赠礼。",
    bank_member_exists: "此银行账号已被使用了。",
    never_deposited : "你必须曾进行过一次有效的存款操作后方可把资金转款到你友人的投注账户内。",
    transferAmountMustGreaterThanEqual5: "转款额必须超过或等值于 5令吉。",
    invalid_transfer_amount: "转款额必须超过或等值于 5令吉。",
    // account_not_exists : "查无此账户信息。"
    permission_denied : "接收者账户不是来自同一个娱乐游戏平台。",
    ongoing_promotion : "你尚参与着正在进行中的优惠活动。",
    insufficient_balance : "账户结余不足",
    transfer_success: "转款成功",
    sender_id_required: "发送者标识不得留空",
    recipient_id_required: "接收者标识不得留空",
    tac_validated: "交易识别码 (TAC) 正确无误。",
    pending_result_in_game: "游戏结果待通知",
    accountIdOnlyNumber: "只限还在使用的有效手机号码而已。",
    unfinishgamedetected: "请在闯过免费游戏关卡后方才执行此步骤。",
    duplicate_review: "你在较早前已提交了一份玩后感言了。",
    exceed_withdrawal_frequency: "已超出提现次数(一天五次)",
    requestTooFrequentAtLeast2Minutes: "您的请求正在处理中， 请稍等",
    invalidPhoneNumberFormat: "请输入正确的电话号码格式",
    gspayUnderMaintenance: "系统正在维护中",
    affiliate_not_exists: "代理链接不存在",
    phoneRequired: '请输入电话号码',
    couponeCodeRequired: "请输入优惠卷代码",
    coupon_code_required: "请输入优惠卷代码",
    coupon_not_available: "优惠卷代码无效",
    contact_email_registered: "电子邮件地址已经存在",
    invalidEmailFormat: "电子邮件地址无效",
    emailRequired: "请输入电子邮件地址",
    paymentMethodRequired: "请选择付款方式",
    depositMethodRequired: "请选择存款方式",
    telcoCodeRequired: "请选择电信公司",
    reloadPinCodeRequired: "请输入充值密码",
    attachment_path_required: "请上传您的交易收据。",
    free_credit_detected: "免费赠金只限用于EpicWin 游戏",

    //new
    amount_required: "金额必须填充",
    auth_token_required: "无法加载",
    bet_id_required: "需要投注编号",
    bonus_unavailable: "暂无奖金",
    client_ip_required: "需要会员IP地址",
    first_deposit_not_met: "需要首次充值",
    ftd_required: "需要首次充值",
    game_maintenance: "目前正在维护当中，请稍后重试",
    gateway_acc_required : "需要支付网站账户",
    inbox_id_required: "需要收件箱ID",
    insufficient_rebate: "奖金回馈不足",
    insufficient_ticket: "奖券不足",
    is_default_required: "需要默认选择",
    min_withdrawal_not_met: "未达到提款最低金额",
    newbie_not_met: "未达到新会员优惠标准",
    no_changes: "默认银行保持不变",
    promotion_not_available:"暂无促销奖金",
    ref_no_required: "需要引荐号",
    result_id_required: "需要结果ID",
    search_id_required: "需要搜索ID",
    setting_not_set: "设置还未配置",
    tac_required: "需要TAC代码",
    ticket_count_required: "需要奖券数额",
    vip_not_exists: "非VIP会员",
    working_date_required: "需要工作日期",
    working_month_required: "需要工作月份",
    withdrawal_amount_lte_withhold_amount: "提款金额少于或者与预扣金额相等",
    providerRequired: "需要提供商",
    invalid_contact_email: "无效邮件",
    invalidUsernameFormat: "用户名字格式无效",
    affiliate_inactive: "会员下线并不活跃",
    insufficient_token: "游戏代币不足",
    LaunchGameFailed: "游戏加载失败",
    "System Error": "系统错误",
    "Server Busy": "服务器繁忙",
    "SERVER BUSY": "服务器繁忙",
    "Not Available": "无法显示",
    undefined: "网络异常，请稍后再试",
    disconnect: "网络异常，请稍后再试",
    unableToLaunchSlotGameAtTheMoment: "目前无法启动游戏",
    launch_fail: "启动游戏错误，请联系管理员",
    playerCreatedError: "启动游戏错误，请联系管理员",
    "Launch Fail": "启动游戏错误，请联系管理员",
    currencyNotSupported : "不支持货币",
    game_not_supported:"您领取的奖金不支持该游戏",
    pending_deposit: "待处理存款",
    "Launch Game Failed" : "启动游戏失败",
  },
  processing: "谢谢，您的交易正在处理中",
  url:{
    mseric1: "http://172.12.5.200:8100/",
    mseric2: "http://172.12.5.200:8101/",
    epicvip: "https://epicwin.vip/",
    epicinfinity: "https://epicwin8.com/",
    epicwin2: "https://epicwin2.com/"
  },
  wrong_site: {
  description: "你的投注账户隶属于 ",
    mseric1: "EpicWinVip",
    mseric2: "EpicWin8",
    epicvip: "EpicWinVip",
    epicinfinity: "EpicWin8",
    epicwin2: "EpicWin2"
  },
  wrong_filetype: "无效文件",

  newpw_required: "请录入全新登录密码",
  newpw_notsame: "全新登录密码组合不得与现用登录密码相同",

  oldpw_required: "请录入现用登录密码。",

  pw_notmatched: "确认密码组合必须与全新密码保持一致",

  forgot_password_success: "临时密码已通过短信发送到您的电话号码。请使用此密码登录。",
  change_password_success: "登录密码已被更新了！！",
  add_bank_success: "成功添加新银行账户！！",

  tac_tooltips: "已把交易识别码 (TAC) 发送至你的手机号码。",
  tac_tooltips1: '请按 "重发" 获取全新的交易识别码 (TAC)',
  tac_countdown: "重发倒数 : {countdown}",

  bank_details_tooltips: "如果你的银行户名与你在EpicWin开户时所使用的全名不能保持一致，则会导致你所提交的提现申请被拒。",
  copy_clipboard: "拷贝链接",
  withdrawal_speed: "提现速度",
  withdrawal_epic: "EPIC 提现榜单",
  withdrawal_topten: "排名前10的提现玩家",
  winner_topten: "排名前10的 EPIC传奇大赢家",

  about_us_1: "<h1>闪速提现</h1><p>通过简化提现审核流程实现交易过程透明，有效缩短提现到账时间。<h1>实事求是</h1><p>EpicWin 真诚对待每一位玩家，做到游戏数据清晰透明，过往游戏记录清楚可查，进而能确保所有玩家都在一个经优化且一视同仁的游戏环境下轻松享玩游戏带来的乐趣。</p>",
  about_us_2: "<h1>所赢即所得</h1><p>我们奉公平原则为圭臬，认为该赏则赏，且应该以合适的方式予以恰当的奖励给值得奖励的对象。这也是为何我们降低赢取总奖池的门槛，甚至每当你进行投注时总是会给予你代币奖励。</p>",
  about_us_3: "<h1>一切由你来决定</h1><p>我们的娱乐游戏平台给予你自主控制的权利。你由始至终都掌握着自由运用你手头上金钱的支配权。你可以选择拿走之，用之下注，或者用之来做任何你感兴趣的事情。<br/>我们觉得你所投入的越多，则你应得的奖励回馈也相应地越丰厚：更有趣的游戏和更丰硕的奖励。<br/>你是否准备以更加新奇有趣且丰富多采的娱乐活动，从日常繁嚣中抽离呢？</p>",

  promo_1_title: "免存赠金",
  promo_1a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>价值100令吉的免存赠金</div><div class='package-table'><div class='row title'><div class='col-4'>免存赠金额</div><div class='col-4'>获赏条件</div><div class='col-4'>提现额</div></div><div class='row table-row'><div class='col-4'>100</div><div class='col-4'>500</div><div class='col-4'>10</div></div></div>",
  promo_1b: "<h1>优惠活动规则</h1><ul><li>玩家必须凭免存赠金赢取至少500令吉，方可申请提取最多10令吉，作为奖励。</li><li>一旦玩家成功提取免存赠金后，显示在其账户内的赢利结余将会被清空归零。</li><li>一旦玩家参与免存赠金优惠活动后，不得再参与其他正在进行的优惠活动，直至达成本优惠活动所规定的获赏条件。</li><li>免存赠金优惠活动不可与其他优惠活动一并使用，如若发现玩家在同一时间内参与超过一个以上的优惠活动，则其所存入的资金将会被悉数没收。</li></ul></h1>",
  general: "<h1>优惠活动通用规则</h1><ul><li>每位玩家每天只能提交5次提现申请而已。</li><li>所有优惠活动皆受列示在EpicWin娱乐游戏平台的平台使用细则与条款所约束。</li></ul>",

  promo_2_title: "荐友限时福利",
  promo_2a: {
    title1: "条件",
    title2: "奖励",
    details1: "好友充值任意数额",
    details2: "10% 返现奖金",
    details3: "被荐好友首次充值 (至少30令吉)",
    details4: "1 张累计奖金彩卷",
    details5: "40位成功注册的好友",
    details6: "1 张累计奖金彩卷",
    tnc: "优惠活动规则",
    tnc_details0: "每位玩家每天只能提交5次提现申请而已。",
    tnc_details1: "你可凭每位荐友的存款领取高达20令吉的10%返现奖励。(任何数目)",
    tnc_details2: "邀请并推荐至少3位好友。每当被荐好友首次充值至少30令吉，你就可获得1 张累计奖金彩卷，作为奖励。",
    tnc_details3: "免费旋转可赢限额为10令吉 (1000枚游戏币)。",
    // tnc_details4: "玩家必须赢得一次胜利方可申请提款10%返现奖励。",
  },

  promo_3_title: "开户迎新彩金",
  promo_3_title_full: "开户迎新彩金 - 一次性奖励",
  promo_3a: {
    title1: "存款额",
    title2: "%",
    title3: "彩金奖励(MYR)",
    title4: "初始结存",
    title5: "累计赢取额",
    details0_1: "10",
    details0_2: "100%",
    details0_3: "10",
    details0_4: "20",
    details0_5: "x3",
    details1_1: "30",
    details1_2: "100%",
    details1_3: "30",
    details1_4: "60",
    details1_5: "x2",
    details2_1: "100",
    details2_2: "120%",
    details2_3: "120",
    details2_4: "220",
    details2_5: "x3",
    details3_1: "300",
    details3_2: "150%",
    details3_3: "450",
    details3_4: "750",
    details3_5: "x5",
    details4: "* 请联系 livechat 以获取开户迎新彩金 100% 存十令吉得二十令吉。",
    tnc: "优惠活动规则",
    tnc_details0: "每位玩家每天只能提交5次提现申请而已。",
    tnc_details1: "只能选择以上其中一项彩金奖励",
    tnc_details2: "此优惠仅适用于首次充值的玩家",
    tnc_details3: "必须达成本优惠所规定的累计赢金额方可申请提款"
  },

  promo_4_title: "每日充值送彩金",
  promo_4a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>每日充值送彩金</div><div class='package-table'><div class='row title'><div class='col-2'>存款额</div><div class='col-2'>彩金奖励率</div><div class='col-2'>彩金奖励额</div><div class='col-2'>初始结存</div><div class='col-2'>提现额</div></div><div class='row table-row'><div class='col-2'>10</div><div class='col-2'>20%</div><div class='col-2'>2</div><div class='col-2'>12</div><div class='col-2'>24</div></div><div class='row table-row'><div class='col-2'>30</div><div class='col-2'>10%</div><div class='col-2'>3</div><div class='col-2'>33</div><div class='col-2'>66</div></div><div class='row table-row'><div class='col-2'>50</div><div class='col-2'>10%</div><div class='col-2'>5</div><div class='col-2'>55</div><div class='col-2'>110</div></div><div class='row table-row'><div class='col-2'>100</div><div class='col-2'>10%</div><div class='col-2'>10</div><div class='col-2'>110</div><div class='col-2'>220</div></div><div class='row table-row'><div class='col-2'>200</div><div class='col-2'>10%</div><div class='col-2'>20</div><div class='col-2'>220</div><div class='col-2'>440</div></div><div class='row table-row'><div class='col-2'>300</div><div class='col-2'>10%</div><div class='col-2'>30</div><div class='col-2'>330</div><div class='col-2'>660</div></div></div>",
  promo_4b: "<h1>优惠活动规则</h1><ul><li>20% 存款彩金乃是限时奖励，每位玩家每天仅限领取存款彩金奖励一次而已 (存款彩金奖励会在每日凌晨12点正刷新)。</li><li>本优惠活动所规定的每笔有效最低存款额为10令吉，并且存款上不封顶。</li><li>玩家必须达成本优惠活动所规定的2倍流水量后方可申请提现。</li></ul>",

  promo_5_title: "日常存款奖励配套",
  promo_5a:{
    title1: "存款额",
    title2: "免费积宝券",
    details1_1: "10",
    details1_2: "50",
    details2_1: "100",
    details2_2: "200",
    details3_1: "500",
    details3_2: "1000",
    details4_1: "500",
    details4_2: "10",
    details5_1: "1000",
    details5_2: "13",
    // details6_1: "2000",
    // details6_2: "10次高级免费旋转",
    // details7_1: "3000",
    // details7_2: "12次高级免费旋转",
    // details8_1: "5000",
    // details8_2: "25次高级免费旋转",
    // details9_1: "10000",
    // details9_2: "50次高级免费旋转",
    // details3: "MYR 10",
    description1: "唯有在以下状况之下方可申领免存彩金:",
    description1_1: "(i) 当前账户结存少于5令吉",
    description1_2: "(ii) 提现额",
    description1_3: "(iii) 当前账户结存归零",
    tnc: "优惠活动规则",
    tnc_details0: "每位玩家每天只能提交5次提现申请而已。",
    tnc_details1: "玩家只需达成本优惠活动所规定的1倍流水量即可申请提现。",
    // tnc_details2: "个别会员的赢利结存将会在其成功提现后悉数清零。",
    // tnc_details3: "凡是参与赠金优惠活动者不得申领其他彩金奖励，直至其达成本优惠活动所规定的最低赢利限额。",
    // tnc_details4: "赠金优惠活动不能与其他优惠活动一并使用。一旦会员被发现使用同一笔存款申领多个优惠活动，则其存款资金将会被全数作废。",
    // tnc_details5: "玩家只需达成本优惠活动所规定的1倍流水量即可申请提现。"
  },
  promo_5b: "<h1>优惠活动规则</h1><ul><li>玩家只需达成本优惠活动所规定的1倍流水量即可申请提现。</li></ul>",

  player_transfer: "<h1>优惠活动规则</h1><ul><li>转款方与收款方必须把资金存入到其在EpicWin娱乐游戏平台所创建的投注账户内。</li><li>如欲进行转款操作，转收款双方在转款过程中，不得参与任何正在本娱乐游戏平台内所进行优惠活动。</li><li>最低转款额: 5令吉。</li><li>转款手续费: 每笔转款征收0.20仙 (由收款方承担)</li><li>一旦转款失败或操作失误，该笔转款额会被悉数打回到转款方的账户里。</li></ul></h1>",
  promo_6_title: "尊享奖金",
  promo_6a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>尊享奖金</div><div class='package-table'><div class='row title'><div class='col-3'>存款额</div><div class='col-3'>奖金额</div><div class='col-3'>初始结存</div><div class='col-3'>提现额</div></div><div class='row table-row'><div class='col-3'>1000</div><div class='col-3'>1500</div><div class='col-3'>2500</div><div class='col-3'>7500</div></div></div>",
  promo_6b: "<h1>优惠活动规则</h1><ul><li>每位玩家仅限在本优惠活动期间领取本奖金一次而已。</li><li>玩家必须赢得本优惠活动所规定的3倍赔付金后方可申请提现。</li></ul>"

};
